/**
 * 不需要改动
 * 接口核心 v0.01
 */
import { qs } from './qs';

/**
 * 请求静态配置
 */
export class RequestAbsConfig<Response = any> {
  errorResponseIntercept?: (x: Response) => any;
  responseIntercept?: (x: Response) => any;
  constructor({
    errorResponseIntercept,
    responseIntercept,
  }: {
    errorResponseIntercept?: (x: Response) => any;
    responseIntercept?: (x: Response) => any;
  } = {}) {
    this.errorResponseIntercept = errorResponseIntercept;
    this.responseIntercept = responseIntercept;
  }
  /**
   * 显示加载
   */
  showLoading(msg: string) { }
  /**
   * 隐藏加载
   */
  hideLoading(msg: string) { }
  /**
   * 错误业务处理
   */
  failHandle(response: Response) {
    return response;
  }
  /**
   * 成功业务处理
   */
  successHandle(response: Response, isMessage: boolean) {
    return response;
  }
  /**
   * 请求之前
   */
  beforeRequest(requestOption: any) { }
  /**
   * 请求之后
   */
  afterRequest() { }
}

export interface CoreCreate {
  requestOption?: {};
  fail?: (response: any) => void;
  success?: (response: any) => void;
  loadingTxt?: string;
  isFailMsg?: boolean;
  isMessage?: boolean;
}

export type Request<T = any> = (args: any) => Promise<T>;

/**
 * 核心请求方法
 */
export class RequestCore<RequestInstance extends Request, Response = any> {
  RTC: InstanceType<typeof RequestAbsConfig>;
  request: RequestInstance;
  constructor(
    request: RequestInstance,
    RequestConfig?: InstanceType<typeof RequestAbsConfig>
  ) {
    this.request = request;
    this.RTC = RequestConfig || new RequestAbsConfig();
    this.create = this.create.bind(this);
  }
  create<T>({
    requestOption = {},
    fail,
    success,
    loadingTxt = '',
    isFailMsg = true,
    isMessage = true,
  }: CoreCreate = {}): Promise<T> {
    const failHandle = (response: Response) => {
      if (response) {
        // 全局提示
        if (isFailMsg) {
          this.RTC.failHandle && this.RTC.failHandle(response);
        }
        // 失败函数自定义提示
        fail && fail(response);
      }
    };
    // 开始请求
    this.RTC.beforeRequest && this.RTC.beforeRequest(requestOption);
    // 请求提示
    this.RTC.showLoading && this.RTC.showLoading(loadingTxt);

    return this.request(requestOption)
      .then((result) => {
        // 关闭加载提示
        this.RTC.hideLoading && this.RTC.hideLoading(loadingTxt);

        // 错误拦截器
        const errResponse = this.RTC.errorResponseIntercept
          ? this.RTC.errorResponseIntercept(result)
          : null;

        // 错误时候
        if (errResponse) {
          failHandle(errResponse);
          return errResponse;
        }

        // 一般拦截器
        const response = this.RTC.responseIntercept
          ? this.RTC.responseIntercept(result)
          : result;

        const res = response.data || {};
        // console.log('res', result, requestOption);
        // 成功返回
        if (response.statusCode == 200) {
          // 成功数据
          success && success(res);
          // 业务处理
          this.RTC.successHandle && this.RTC.successHandle(res, isMessage);
        } else {
          failHandle(response);
        }
        return res;
      })
      .catch((result: any) => {
        // 关闭加载提示
        this.RTC.hideLoading && this.RTC.hideLoading(loadingTxt);
        // 错误拦截器
        const errResponse = this.RTC.errorResponseIntercept
          ? this.RTC.errorResponseIntercept(result)
          : null;

        // 一般拦截器
        const response =
          this.RTC.responseIntercept && !errResponse
            ? this.RTC.responseIntercept(result)
            : result;

        const failResponse = errResponse || response;
        failHandle(failResponse);
        return failResponse;
      });
  }
}

interface RequestHttpProps<RequestInstance, RequestOption> {
  core?: InstanceType<typeof RequestCore>;
  request?: RequestInstance;
  baseDomain?: string;
  requestConfig?: InstanceType<typeof RequestAbsConfig>;
  requestOption?: RequestOption;
}

// 支持path参数格式/xxx/{id}、/xxx/:id
const urlParamsReg = /\{(.*?)\}|:(.*?)((?=\/)|$)/g;

export interface RequestHttpInstanceProps {
  /** 请求对象 */
  requestOption?: {
    [x: string]: any;
  };

  /** 请求头，覆盖requestOption.header */
  header?: {
    [x: string]: any;
  };

  /** 拼接路径 */
  path?: string;

  /** url路径上参数: /xxx/{id} */
  urlParams?: {
    [x: string]: any;
  };

  /** 数据，覆盖requestOption.data，优先级比params高 */
  data?: any;

  /** url参数，覆盖requestOption.params */
  params?: {
    [x: string]: any;
  };
  /** 加载文字 */

  loadingTxt?: string;
  /** 失败回调函数 */

  fail?: any;
  /** 成功回调函数 */
  success?: any;

  /** 是否提醒服务正常响应信息 */
  isMessage?: boolean;

  /** 是否提醒服务正常响应信息（请使用isMessage） */
  isMsg?: boolean;

  /** 是否提醒服务、通信的错误信息 */
  isFailMsg?: boolean;

  /** 自动 url query String */
  isUrlQs?: boolean;
}

export class RequestHttp<
  RequestInstance extends Request,
  RequestOption extends { [x: string]: any }
> {
  core: InstanceType<typeof RequestCore>;
  baseDomain?: string;
  requestOption?: RequestOption;
  constructor({
    core,
    request,
    baseDomain = '',
    requestConfig,
    requestOption,
  }: RequestHttpProps<RequestInstance, RequestOption> = {}) {
    if (core) {
      this.core = core;
    } else {
      if (!request) {
        throw new Error('RequestHttp: The constructor request is not found');
      }
      this.core = new RequestCore<RequestInstance>(request, requestConfig);
    }
    this.baseDomain = baseDomain;
    this.requestOption = requestOption;
    this.create = this.create.bind(this);
    this.intercept = this.intercept.bind(this);
  }
  /**
   * 接口参数拦截
   */
  intercept<T>(rootPath: string, method = 'GET', domain: string) {
    return (props?: RequestHttpInstanceProps | string) => {
      const {
        requestOption = {
          ...this.requestOption,
        },
        header = {},
        path = '',
        urlParams = {},
        data = undefined,
        params = {},
        loadingTxt = '',
        fail = undefined,
        success = undefined,
        isMessage = true,
        isMsg = true,
        isFailMsg = true,
        isUrlQs = false,
      } = typeof props === 'string' ? {} : props || {};

      // 整个参数就一个字符串
      let oneParams = '';
      if (typeof props === 'string') {
        oneParams = props;
      }

      let rawPath = `${rootPath}${path}`;

      // 解析url路径参数
      const urlParamsArr = [...new Set(rawPath.match(urlParamsReg) || [])];
      if (urlParamsArr.length > 0) {
        urlParamsArr.forEach(function (_key) {
          const key = _key.replace('{', '').replace('}', '').replace(':', '');
          rawPath = rawPath.replace(
            new RegExp(_key, 'g'),
            urlParams[key] || oneParams || ''
          );
        });
      } else if (oneParams) {
        rawPath += oneParams;
      }

      let url = `${domain || this.baseDomain}${rawPath}`;

      let inData: undefined | { [x: string]: any } = data;
      let inParams: undefined | { [x: string]: any } = params;
      if (method === 'GET') {
        inData = inData ? inData : params;
        inParams = inParams ? inParams : inData;
      }

      if (isUrlQs) {
        const [urlPath, urlQuery] = url.split('?');
        const query = urlQuery ? qs.parse(urlQuery) : {};
        const queryString = qs.stringify({
          ...query,
          ...inParams,
        });
        url = `${urlPath}?${queryString}`;
        inParams = {};
      }

      const inHeader = {
        ...(requestOption.header || {}),
        ...header,
      };

      const reqOption = {
        ...requestOption,
        url,
        data: inData,
        params: inParams,
        header: inHeader,
        method,
      };
      return (
        this.core &&
        this.core.create<T>({
          requestOption: reqOption,
          fail,
          success,
          loadingTxt,
          isFailMsg,
          isMessage: isMessage === false || isMsg === false ? false : true,
        })
      );
    };
  }
  create<T>(path: string, method: string, domain: string = '') {
    //特殊类型的method
    const methodMap: { [x: string]: string } = {
      path: 'GET',
      pathPost: 'POST',
    }; //真实的method：get和post
    const inMethod = methodMap[method] || method;
    return this.intercept<T>(path, inMethod, domain);
  }
}
